export function CalculatedCart() {


	this.productsInCart = [];
	this.textItems = [];
	this.currencyId = 0;
	this.countryId = 0;

	this.bonusCouponId = 0;
	this.priceTable = {
		priceInclVat: 0,
		discountExclVat: 0,
		totalPriceExclVat: 0,
		totalPriceInclVat: 0,

	};
}